module.exports = __webpack_public_path__ + "9fcbe36af7bc81b47486fa11aaacd663.svg";